import cn from 'classnames';
import { SchedulerDayColumn, ShiftSiblingData } from '@lp/features/Scheduler/types';
import { OMSShiftCell, OMSShiftEmptyCell } from '@lp/features/Scheduler/SchedulerOMS/components';
import { OMSOnCallResource } from '@lp/features/Scheduler/SchedulerOMS';
import { shiftButtonHoverClassname } from '@lp/features/Scheduler/constants';
import { DayGridCellWrapper } from '@lp/features/Scheduler/components';
import { OMSOnCallResourceCellItem } from './OMSOnCallResourceCellItem';
import { OMSShift, OMSShiftSelectPayload } from '@/api/apis/resources/schedule';

type OMSDayGridCellProps = {
  myId: string;
  column: SchedulerDayColumn;
  shiftData: OMSShift;
  siblingData?: ShiftSiblingData;
  onCallResources?: OMSOnCallResource[];
  isPersonalView?: boolean;
  isEditable: boolean;
  canReset: boolean;
  onShiftChange: (shiftPayload?: OMSShiftSelectPayload) => void;
};

export const OMSDayGridCell = ({
  myId,
  column,
  shiftData,
  siblingData,
  onCallResources,
  isPersonalView,
  isEditable,
  canReset,
  onShiftChange,
}: OMSDayGridCellProps) => {
  const disabled = isPersonalView ? !isEditable : true;
  const readonly = disabled || !column.isCurrentMonth || column.isPast;

  return (
    <DayGridCellWrapper column={column}>
      {isPersonalView ? (
        <div
          className={cn('static px-2 pb-2 h-full', {
            'ps-0': siblingData?.hasPrev,
            'pe-0': siblingData?.hasNext,
          })}
        >
          {shiftData ? (
            <OMSShiftCell
              shiftData={shiftData}
              siblingData={siblingData}
              lighten={!column.isCurrentMonth}
              readonly={readonly}
              isCentered
              canReset={canReset}
              onShiftChange={onShiftChange}
            />
          ) : (
            !readonly && <OMSShiftEmptyCell onShiftChange={onShiftChange} />
          )}
        </div>
      ) : (
        <div className="relative mx-2 mb-2 rounded overflow-hidden">
          <button
            disabled={disabled}
            className={cn('flex flex-col gap-1.5 w-full', {
              [shiftButtonHoverClassname]: !disabled,
              'opacity-60': !column.isCurrentMonth,
            })}
          >
            {onCallResources?.map((r) => (
              <OMSOnCallResourceCellItem key={`${r.id}-${r.slotIndex}`} isMe={myId === r.id} resource={r} />
            ))}
          </button>
        </div>
      )}
    </DayGridCellWrapper>
  );
};
